import "@memorial/scss/app-memorial-front-page.scss"
import Utils from "@otpaysdefalaise/js/services/utils"
import Slider from "@otpaysdefalaise/js/services/slider"
import Menu from "@otpaysdefalaise/js/services/menu"
import Modernizr from "modernizr";
import Swiper from "swiper";
import {add_swiper_class} from '@otpaysdefalaise/js/tools/swiper';

document.addEventListener("DOMContentLoaded", function () {
    // Menu
    new Menu()

    // Utils
    Utils.click()
    Utils.bootstrap()
    Utils.searchbox()
    Utils.smooth_scroll()
    Utils.lazy()
    Utils.obfuscation()
    Utils.sticky_navbar()
    Utils.facebookEvent()
    Utils.infoLive()
    Utils.langs_switcher()
    Slider.hero();
    strateEssentials();
    strateEvents();
    strateVisits();
    stratePlan();
    strateSocial();


    /**
     * Slider home events
     */
    function strateEssentials() {
        const slider = '[data-id="wpiris-essentials-slider"]',
            slider_wrapper = '[data-id="wpiris-essentials-slider-wrapper"]',
            slider_item = '[data-essential-slide]',
            button = '[data-essential-link]';

        if ($(slider).length > 0) {

            add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

            const config = {
                slidesPerView: 1,
                autoplay: {
                    delay: 3000
                },
                speed: 600,
                lazy: true,
                scrollbar: $(slider_item).length > 1 ? {
                    el: '[data-trigger="swiper-scrollbar-essentials"]',
                    draggable: true,
                    hide: false
                } : {},
                on: {
                    transitionEnd: () => {
                        const activePost = $(slider_item + '.swiper-slide-active').data('essential-item');
                        const permalink = $(slider_item + '.swiper-slide-active').data('essential-permalink');
                        $('.strateEssentialsContent').removeClass('is-active');
                        $('[data-essentials-id="' + activePost + '"]').addClass('is-active');
                        $(button).attr('href', permalink);
                    }
                }
            }

            if (Modernizr.touchevents) {
                config.allowTouchMove = true;
            }

            new Swiper($(slider), config);
        }
    }

    function strateEvents(){
        Slider.home_events()

        const trigger = $('[data-trigger="wpiris-filter-agenda"]')
        if (trigger.length > 0) {
            trigger.on("click", function () {
                $("#agendaPeriod").val($(this).attr("rel"))
                $("#agendaActions").submit()
            })
        }
    }

    function strateVisits() {

        const slider = '[data-id="wpiris-related-post"]',
            slider_wrapper = '[data-id="wpiris-related-post-wrapper"]',
            slider_item = '[data-swiper-item]';

        if ($(slider).length > 0) {

            $(slider).each(function () {

                add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

                const slides_per_view = undefined !== $(this).attr('data-slides-per-view') ? $(this).attr('data-slides-per-view') : 3,
                    slides_per_view_large = undefined !== $(this).attr('data-slides-per-view-large') ? $(this).attr('data-slides-per-view-large') : 3,
                    slides_per_view_medium = undefined !== $(this).attr('data-slides-per-view-medium') ? $(this).attr('data-slides-per-view-medium') : 2.2,
                    slides_per_view_small = undefined !== $(this).attr('data-slides-per-view-small') ? $(this).attr('data-slides-per-view-small') : 1.2;

                new Swiper($(this), {
                    slidesPerView: slides_per_view_small,
                    spaceBetween: 10,
                    speed: 600,
                    keyboard: true,
                    watchSlidesVisibility: true,
                    passiveListeners: false,
                    scrollbar: {
                        el: '[data-trigger="swiper-scrollbar-related-post"]',
                        draggable: true,
                        hide: false
                    },
                    breakpoints: {
                        350: {
                            slidesPerView: slides_per_view_small,
                            spaceBetween: 20,
                        },
                        650: {
                            slidesPerView: slides_per_view_medium,
                            spaceBetween: 20,
                        },
                        1000: {
                            slidesPerView: slides_per_view_large,
                            spaceBetween: 20,
                        },
                        1381: {
                            slidesPerView: slides_per_view,
                            spaceBetween: 40,
                        }
                    }
                });

            });
        }
    }

    function stratePlan() {
        const slider = '[data-id="wpiris-plan-slider"]',
            slider_wrapper = '[data-id="wpiris-plan-slider-wrapper"]',
            slider_item = '[data-plan-slide]';

        if ($(slider).length > 0) {
            add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

            const planSwiper = new Swiper($(slider), {
                slidesPerView: 1,
                speed: 600,
                effect: 'fade',
                fadeEffect: { crossFade: true },
                allowTouchMove: false,
                navigation: {
                    prevEl: '[data-trigger="plan-prev"]',
                    nextEl: '[data-trigger="plan-next"]',
                }
            });
        }
    }

    function strateSocial(){
        Utils.initialize_instagram();
    }
})
